<!-- 管理员修改密码 -->
<template>
	<div class="changePassword_page">
		<a-form-model ref="ruleForm" :model="form" :label-col="labelCol" :wrapper-col="wrapperCol" :rules="marketRules">
			<a-row>
				<a-col :span="12">
					<a-form-model-item label="旧密码" prop="oldPassword">
						<a-input v-model="form.oldPassword" type="password" placeholder="请输入旧密码"></a-input>
					</a-form-model-item>
					<a-form-model-item label="新密码" prop="newPassword">
						<a-input v-model="form.newPassword" type="password" placeholder="请输入新密码"></a-input>
					</a-form-model-item>
					<a-form-model-item label="">
						<a-button style="margin-left: 135px" @click="toSubmit" type="primary">提交</a-button>
					</a-form-model-item>
				</a-col>
				<a-col :span="12"> </a-col>
			</a-row>
		</a-form-model>
	</div>
</template>

<script>
	import {
		changePasswordApi
	} from "../../api/index";
	export default {
		name: "changePassword",
		data() {
			return {
				labelCol: {
					span: 4
				},
				wrapperCol: {
					span: 18
				},
				form: {
					oldPassword: "",
					newPassword: ""
				},
				marketRules: {
					oldPassword: [{
						required: true,
						message: "请输入旧密码",
						trigger: "change"
					}, ],
					newPassword: [{
						required: true,
						message: "请输入新密码",
						trigger: "change"
					}, ],
				},
			};
		},
		methods: {
			toSubmit() {
				this.$refs.ruleForm.validate((valid) => {
					if (valid) {
						changePasswordApi({
							oldPassword: this.form.oldPassword,
							newPassword: this.form.newPassword,
						}).then((res) => {
							if (res.resultStatus) {
								this.$message.success("修改密码成功，请重新登陆");
								localStorage.removeItem("accessToken");
								this.$router.push("/");
								this.$store.commit("CLEAR_VUEX");
							} else {
								this.$message.warn(res.errorMessage);
							}
						});
					}
				});
			},
		},
	};
</script>

<style lang="less">
	.changePassword_page {
		width: 100%;
		height: 100%;
		padding: 10px;
		background: #ffffff;

		.filter_box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-bottom: 12px;
		}

		.mr12 {
			margin-right: 12px;
		}
	}
</style>